import type { ButtonHTMLAttributes, FC, ReactNode } from "react";
import cx from "classnames";
import s from "./Button.module.css";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  appearance?: "primary" | "secondary";
  children: ReactNode;
};

export const Button: FC<ButtonProps> = ({
  children,
  appearance = "secondary",
  ...props
}) => (
  <button
    {...props}
    className={cx(
      props.className,
      appearance === "primary" && s.primary,
      s.root
    )}
  >
    {children}
  </button>
);
